<template>
  <b-modal
    centered
    ref="modal-new"
    v-model="showModalNewConversation"
    title="Nova Conversa"
  >
    <b-form-group label="Selecione um Provedor" label-for="cmb-provider">
      <b-form-select
        id="mode-select"
        class="w-100"
        v-model="typeOption"
        required
      >
        <b-form-select-option
          v-for="option in types"
          :key="option.id"
          :value="option.name"
        >
          {{ option.name }}
        </b-form-select-option>
      </b-form-select>
      <div class="invalid-feedback">
        Por favor, forneça um número válido.
      </div>
    </b-form-group>
    <b-form-group
      label="Número para envio do Ativo"
      label-for="conversation-send"
    >
      <b-form-input
        id="conversation-send"
        v-model="numberProvider"
        v-mask="botmakerMask"
        disabled
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Nome" label-for="conversation-person">
      <b-form-input
        id="conversation-person"
        v-model="newConversationPerson"
        disabled
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Telefone" label-for="conversation-subject">
      <b-form-input
        id="conversation-subject"
        v-model="newConversationSubject"
        v-mask="phoneMask"
        required
        disabled
      ></b-form-input>
    </b-form-group>
    <div v-if="typeOption !== 'BOTMAKER'">
      <b-form-group
        label="Parâmetro do HSM"
        label-for="conversation-hsm"
        v-if="isWhatsMeta"
      >
        <b-form-select
          id="conversation-hsm"
          @change="updateHsmText"
          v-model="selectedHsm"
          required
        >
          <b-form-select-option v-for="hsm in hsms" :key="hsm.id" :value="hsm.id">
            {{ hsm.hsmName }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
    </div>
    <div v-if="isWhatsMeta">
      <b-form-group
        v-for="(param, index) in templateParameters"
        :key="index"
        :label="'Parâmetro ' + param.name"
      >
        <b-form-input v-model="param.text" required></b-form-input>
      </b-form-group>
    </div>
    <div v-if="typeOption !== 'BOTMAKER'">
      <b-form-group
        label="Mensagem"
        label-for="conversation-subject"
      >
        <b-form-textarea
          id="conversation-subject"
          v-model="newConversationMessage"
          :disabled="isWhatsMeta"
          required
        ></b-form-textarea>
      </b-form-group>
    </div>

    <template #modal-footer>
      <div class="w-100 text-right">
        <button
          v-if="typeOption === 'BOTMAKER'"
          type="button"
          class="btn btn-third btn-sm mr-2"
          @click="sendBotmakerRequest"
          :disabled="isLoadingBotmaker"
          v-b-tooltip.hover
          :title="isLoadingBotmaker ? 'Buscando chat...' : 'Enviar para Botmaker'"
        >
          <i :class="isLoadingBotmaker ? 'fas fa-spinner fa-spin' : 'fas fa-paper-plane'" class="mr-1"></i>
          <span class="d-md-down-none">{{ isLoadingBotmaker ? 'Buscando chat...' : 'Enviar Botmaker' }}</span>
        </button>
        <button
          v-if="typeOption !== 'BOTMAKER'"
          type="button"
          class="btn btn-third btn-sm"
          @click="createConversation"
          v-b-tooltip.hover
          :title="'Criar'"
        >
          <i class="fas fa-check-circle"></i
          ><span class="d-md-down-none">Criar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import NumRepository from '@/shared/http/repositories/access/cadastroNum'
import HsmRepository from '@/shared/http/repositories/configurations/hsm'
import BotmakerRepository from '@/shared/http/repositories/botmaker/botmaker'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'AssociateCreateNotProvider',
  data () {
    return {
      showModalNewConversation: false,
      newConversationPerson: '',
      newConversationSubject: '',
      newConversationMessage: '',
      originalMessage: '',
      types: [],
      typeOption: '',
      idProvider: 1,
      hsms: [],
      templateParameters: [],
      variables: [],
      hsmId: '',
      objectHsm: null,
      selectedHsm: '',
      numberProvider: '',
      identifierProvider: '',
      conversationInfo: null,
      selectedHsmObj: null,
      isLoadingBotmaker: false
    }
  },
  mixins: [AccountMixin],
  props: {
  },
  computed: {
    selectedTypeData () {
      return this.types.find(type => type.name === this.typeOption)
    },
    isWhatsMeta () {
      return this.selectedTypeData && this.selectedTypeData.type === 'WHATS_META'
    },
    phoneMask () {
      // Detecta se é número 0800 baseado no valor atual
      if (this.newConversationSubject && this.newConversationSubject.startsWith('0800')) {
        return '#### ## ####'
      }
      // Para números normais
      return ['(##) ####-####', '(##) # ####-####']
    },
    botmakerMask () {
      console.log('🔍 botmakerMask - typeOption')
      if (this.typeOption === 'BOTMAKER') {
        console.log('✅ Aplicando máscara BOTMAKER: #### #### ###')
        return '#### #### ###'
      }
      console.log('📞 Aplicando máscara normal')
      return ['(##) ####-####', '(##) # ####-####']
    }
  },
  created () {
    this.loadNumbers()
    this.loadHms()
  },
  watch: {
    typeOption (newVal) {
      const selectedType = this.types.find(type => type.name === newVal)
      if (selectedType) {
        this.numberProvider = selectedType.formattedNumber
        this.identifierProvider = selectedType.number
        this.newConversationMessage = ''

        // Se for BOTMAKER, reformatar o número para formato 0800
        if (newVal === 'BOTMAKER' && this.numberProvider) {
          this.formatBotmakerNumber()
        }
      }
    },
    templateParameters: {
      handler: 'updateMessage',
      deep: true
    }
  },
  methods: {
    async createConversation () {
      const selectedType = this.types.find(type => type.name === this.typeOption)
      if (selectedType) {
        if (selectedType.type === 'WHATS_META') {
          this.isMeta()
        } else if (selectedType.type === 'WHATS_WPP') {
          this.isWPP()
        } else if (this.typeOption === 'BOTMAKER') {
          this.isBotmaker()
        }
      }
    },
    async isWPP () {
      const selectedType = this.types.find(type => type.name === this.typeOption)
      const identifierFormat = this.newConversationSubject.replace(/\D/g, '')
      const requestConfig = {
        identifier: identifierFormat,
        operatorId: this.account.id,
        status: 'A',
        provider: selectedType.type.toLowerCase(),
        type: 'chat',
        message: {
          type: 'text',
          text: this.newConversationMessage
        },
        name: this.newConversationPerson,
        botId: 'NDA',
        identifierProvider: this.identifierProvider
      }
      try {
        const response = await AtendimentoRepository.CreateConversation(requestConfig)
        this.clearFields()
        this.closeModal()

        // Redirecionar para a página de atendimento com os dados da conversa
        this.$router.push({
          path: '/atendimento',
          params: { newConversation: response.data }
        })

        // Mostrar mensagem de sucesso
        this.$bvToast.toast('Conversa criada com sucesso! Redirecionando para o atendimento...', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Erro ao criar conversa. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    async isMeta () {
      const selectedType = this.types.find(type => type.name === this.typeOption)
      const identifierFormat = this.newConversationSubject.replace(/\D/g, '')
      const components = []
      if (this.selectedHsmObj.hasImage) {
        const component = {
          type: 'header',
          parameters: [
            {
              type: 'image',
              image: {
                id: this.selectedHsmObj.hsmImageId
              }
            }
          ]
        }
        components.push(component)
      }
      components.push({
        type: 'body',
        parameters: this.templateParameters.map(param => ({
          name: param.name,
          type: param.type,
          text: param.text
        }))
      })
      const requestConfig = {
        identifier: identifierFormat,
        operatorId: this.account.id,
        status: 'A',
        provider: selectedType.type.toLowerCase(),
        type: 'template',
        message: {
          type: 'template',
          template: {
            name: this.hsmId,
            components
          }
        },
        name: this.newConversationPerson,
        botId: 'NDA',
        identifierProvider: this.identifierProvider
      }
      try {
        const response = await AtendimentoRepository.CreateConversation(requestConfig)
        this.clearFields()
        this.closeModal()

        // Redirecionar para a página de atendimento com os dados da conversa
        this.$router.push({
          path: '/atendimento',
          params: { newConversation: response.data }
        })

        // Mostrar mensagem de sucesso
        this.$bvToast.toast('Conversa criada com sucesso! Redirecionando para o atendimento...', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Erro ao criar conversa. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    formatBotmakerNumber () {
      console.log('🔧 Formatando número para BOTMAKER')
      // Remover todos os caracteres não numéricos
      const cleanNumber = this.numberProvider.replace(/\D/g, '')
      console.log('🧹 Número limpo')
      // Se o número começa com 0800, aplicar formatação específica
      if (cleanNumber.startsWith('0800')) {
        // Formatar como 0800 3004 200
        const formatted = cleanNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3')
        this.numberProvider = formatted
      }
    },
    async sendBotmakerRequest () {
      // Verificar se temos os dados da pessoa e o documento
      if (!this.conversationInfo || !this.conversationInfo.pessoa || !this.conversationInfo.pessoa.document) {
        console.error('DEBUG: CPF/CNPJ não encontrado')
        toast.error('CPF/CNPJ não encontrado para esta pessoa.')
        return
      }

      // Pegar o documento (CPF/CNPJ) e sanitizar (remover pontos, traços, etc)
      const document = this.conversationInfo.pessoa.document.replace(/\D/g, '')
      console.log('DEBUG: Documento sanitizado:', document)

      this.isLoadingBotmaker = true

      try {
        console.log('DEBUG: Iniciando requisição para Botmaker...')
        const response = await BotmakerRepository.GetChatId(document)
        console.log('DEBUG: Resposta recebida:', response)
        console.log('DEBUG: response.data:', response.data)
        console.log('DEBUG: Tipo de response.data:', typeof response.data)

        // Verificar se encontrou o chat
        if (response.data && response.data.trim() !== '') {
          console.log('DEBUG: Chat encontrado! ChatId:', response.data)
          toast.success('Chat encontrado! Redirecionando para a conversa...')
          // Processar a resposta e abrir a URL do Botmaker
          this.handleBotmakerResponse(response.data)
          this.clearFields()
          this.closeModal()
        } else {
          console.log('DEBUG: Chat não encontrado (response vazio ou null)')
          toast.warning(`Nenhum chat encontrado no Botmaker para o emissor ${this.numberProvider}`)
          this.openBotmakerUrl()
        }
      } catch (error) {
        console.error('❌ Erro ao fazer requisição para Botmaker:', error)
        console.error('🔍 Detalhes do erro:', {
          message: error.message,
          status: error.response && error.response.status,
          statusText: error.response && error.response.statusText,
          data: error.response && error.response.data
        })
        console.error('📋 Resposta completa do erro:', error.response)
        console.error('📋 Configuração da requisição:', error.config)

        // Mostrar dados da resposta de erro se existirem
        if (error.response && error.response.data) {
          console.error('📄 Dados da resposta de erro:', error.response.data)
        }

        // Tratamento específico para diferentes tipos de erro
        let errorMessage = 'Erro ao enviar requisição para Botmaker.'

        if (error.response && error.response.status === 400) {
          errorMessage = 'Erro 400: Problema na configuração do backend.'
        } else if (error.response && error.response.status === 401) {
          errorMessage = 'Erro 401: Token de autenticação inválido ou não configurado no backend.'
        } else if (error.response && error.response.status === 404) {
          errorMessage = 'Erro 404: Endpoint ou chat não encontrado. Verifique se a URL está correta.'
        } else if (error.response && error.response.status === 500) {
          errorMessage = 'Erro 500: Erro interno do servidor. Verifique os logs do backend.'
        }

        console.error('💡 Mensagem de erro personalizada:', errorMessage)

        // Mostrar toast de erro
        toast.warning(`Chat não encontrado para o emissor ${this.numberProvider}`)

        // Em caso de erro, abrir URL padrão do Botmaker
        this.openBotmakerUrl()
      } finally {
        this.isLoadingBotmaker = false
      }
    },
    handleBotmakerResponse (data) {
      // Log removido por segurança - não expor dados do Botmaker

      // Verificar se o chatId existe e não é nulo/vazio
      let chatId = null

      if (data && typeof data === 'string' && data.trim() !== '') {
        // Se data é uma string não vazia
        chatId = data.trim()
      } else if (data && data.chatId && data.chatId.trim() !== '') {
        // Se data é um objeto com propriedade chatId
        chatId = data.chatId.trim()
      } else if (data && data.chat && data.chat.chatId && data.chat.chatId.trim() !== '') {
        // Se data é um objeto aninhado com chat.chatId
        chatId = data.chat.chatId.trim()
      }

      if (chatId) {
        console.log('✅ ChatId encontrado')
        this.openBotmakerUrl(chatId)
      } else {
        console.log('⚠️ ChatId não encontrado ou vazio, abrindo URL padrão')
        this.openBotmakerUrl()
      }
    },
    openBotmakerUrl (chatId = null) {
      let url = 'https://go.botmaker.com/#/chats/'

      if (chatId) {
        url = `https://go.botmaker.com/#/chats/${chatId}`
        console.log('🔗 Abrindo URL do Botmaker com chatId')
      } else {
        console.log('🔗 Abrindo URL padrão do Botmaker')
      }

      // Abrir em nova janela
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    async isBotmaker () {
      // const phoneNumber = this.newConversationSubject.replace(/\D/g, '')
      try {
        // const response = await this.$http.get(`api/v1/botmaker/chat-id/${phoneNumber}`)
        // Log removido por segurança - não expor dados do Botmaker
        // Aqui você pode processar a resposta conforme necessário
        this.clearFields()
        this.closeModal()
      } catch (error) {
        console.error('Erro ao fazer requisição para Botmaker:', error)
        // Aqui você pode tratar o erro conforme necessário
      }
    },
    replacePlaceholders (message) {
      return message
        .replace(/@Nome@/gi, this.newConversationPerson)
        .replace(/@Telefone@/gi, this.newConversationSubject)
        .replace(/@Email@/gi, this.conversationInfo.pessoa.email)
    },
    getValueParameters (parametro) {
      if (parametro.toLowerCase() === 'nome') {
        return this.newConversationPerson
      } else if (parametro.toLowerCase() === 'celular') {
        return this.newConversationSubject
      } else if (parametro.toLowerCase() === 'email') {
        if (this.conversationInfo) {
          return this.conversationInfo.pessoa.email
        } else {
          return ''
        }
      }
      return ''
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    async loadHms () {
      try {
        const response = await HsmRepository.GetAll()
        this.hsms = response.data.content
      } catch (error) {
        console.error('Erro ao carregar HSMs:', error)
      }
    },
    async loadNumbers () {
      try {
        const requestConfig = {
          params: {
            active: 1
          }
        }
        const response = await NumRepository.getEnvAll(requestConfig)
        this.types = response.data.content
      } catch (error) {
        console.error('Erro ao carregar números:', error)
      }
    },
    openModal (conversationInfo, telefone) {
      this.conversationInfo = conversationInfo
      if (this.conversationInfo && this.conversationInfo.pessoa) {
        this.newConversationPerson = this.conversationInfo.pessoa.nome
      }
      this.newConversationSubject = telefone

      // Se houver apenas um provedor, selecionar automaticamente
      if (this.types && this.types.length === 1) {
        this.typeOption = this.types[0].name
      }

      this.showModalNewConversation = true
    },
    closeModal () {
      this.showModalNewConversation = false
    },
    clearFields () {
      this.newConversationPerson = ''
      this.newConversationSubject = ''
      this.newConversationMessage = ''
      this.originalMessage = ''
      this.typeOption = ''
      this.selectedHsm = ''
      this.numberProvider = ''
      this.identifierProvider = ''
    },
    updateHsmText () {
      const selectedHsmObj = this.hsms.find(hsm => hsm.id === this.selectedHsm)
      if (selectedHsmObj) {
        this.selectedHsmObj = selectedHsmObj
        this.newConversationMessage = selectedHsmObj.hsmText
        this.originalMessage = selectedHsmObj.hsmText
        this.variables = selectedHsmObj.variaveisHsmList
        this.templateParameters = this.variables.map(variable => ({
          name: variable,
          type: 'text',
          text: this.getValueParameters(variable)
        }))
        this.hsmId = selectedHsmObj.hsmId
      }
    },
    updateMessage () {
      let message = this.originalMessage
      this.templateParameters.forEach(param => {
        let regex = new RegExp(`@${param.name}@`, 'gi')
        message = message.replace(regex, param.text)
        if (param.name.toLowerCase() === 'celular') {
          regex = new RegExp('@Telefone@', 'gi')
          message = message.replace(regex, param.text)
        }
      })
      this.newConversationMessage = message
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/components/associateCreate.vue